import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import LuciPropTypes from '../../propTypes/';
import ControlBar from '../../components/TemplateSelection/ControlBar';
import { Container, MainContent, StickyHeader } from '../../styled-components/Layout';
import Pagination from '../../components/Pagination';
import AssetList from '../../components/AssetList';
import { actions as assetActions } from '../../actions/asset';
import { actions as assetsActions } from '../../actions/assets';
import { actions as appActions } from '../../actions/app';

const PaginationContainer = styled.div`
  position: fixed;
  bottom: .5rem;
  right: 64%;
  flex-direction: column;
`;

const OverlayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 100%;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const DisabledOverlay = styled.span`
  font-size: 18px;
  color: grey;
`;

class ClipperTemplatesSelection extends PureComponent {
  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const categoriesPopulated = nextProps.categoryList && nextProps.categoryList.length > 0;
    const contextsPopulated = nextProps.contextList && nextProps.contextList.length > 0;
    const optionsInitialized = contextsPopulated && categoriesPopulated;
    const assetsNeedUpdate = nextProps.needUpdate;
    const assetsLoading = nextProps.assetsLoading;

    if (assetsNeedUpdate && userLoggedIn && optionsInitialized && !assetsLoading) {
      this.props.getAssets();
    }
  }

  render() {
    const {
      assetList,
      selectedAssetId,
      toggleFavorite,
      loadAsset,
      assetsLoading,
      changePage,
      pageNumber,
      totalPages,
      reload,
      error,
      shortcuts } = this.props;
    if (this.props.enabled) {
      return (
        <Container>
          <StickyHeader>
            <ControlBar />
          </StickyHeader>
          <MainContent>
            <AssetList
              assetList={assetList}
              selectedAssetId={selectedAssetId}
              toggleFavorite={toggleFavorite}
              onDoubleClick={(res) => {
                loadAsset(res.id, true);
              }}
              loading={assetsLoading}
              reload={reload}
              error={error}
            />
            <PaginationContainer>
              <Pagination
                nextPageShortcut={shortcuts.nextPage}
                prevPageShortcut={shortcuts.prevPage}
                totalPages={totalPages}
                currentPage={pageNumber}
                buffer={2}
                onChange={changePage}
              />
            </PaginationContainer>
          </MainContent>
        </Container>
      );
    }
    return (
      <OverlayContainer>
        <DisabledOverlay>Double click a movie to open in viewer.</DisabledOverlay>
      </OverlayContainer>
    );
  }
}

ClipperTemplatesSelection.defaultProps = {
  selectedAssetId: null
};

ClipperTemplatesSelection.propTypes = {
  assetList: LuciPropTypes.AssetList.isRequired,
  selectedAssetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toggleFavorite: PropTypes.func.isRequired,
  loadAsset: PropTypes.func.isRequired,
  getAssets: PropTypes.func.isRequired,
  assetsLoading: PropTypes.bool.isRequired,
  changePage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  reload: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  shortcuts: PropTypes.shape({
    nextPage: PropTypes.arrayOf(PropTypes.string),
    prevPage: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

const mapActionCreators = {
  toggleFavorite: assetsActions.toggleFavorite,
  loadAsset: assetActions.loadAsset,
  getAssets: assetsActions.getAssets,
  reload: assetsActions.reload,
  changeSidebarState: appActions.changeSidebarState,
  changePage: assetsActions.changePage
};

const mapStateToProps = (state) => ({
  sidebar: state.app.sidebar,
  authenticated: state.auth.authenticated,
  assetList: state.assets.assetList,
  userId: state.auth.user.userId,
  assetsLoading: state.assets.assetsLoading,
  needUpdate: state.assets.needUpdate,
  contextList: state.assets.contextList,
  categoryList: state.assets.categoryList,
  selectedAssetId: state.asset.selectedAssetId,
  pageNumber: state.assets.pageNumber,
  totalPages: state.assets.totalPages,
  error: state.assets.error,
  shortcuts: state.keyShortcuts.shortcuts
});

export default connect(mapStateToProps, mapActionCreators)(ClipperTemplatesSelection);



// WEBPACK FOOTER //
// ./app/components/Clipper/ClipperTemplatesSelection.js